import React from 'react';
import moment from 'moment'; // Assuming you have moment.js installed for date formatting

const SubscriptionCard = ({ userData, setConfirmModal, setSubcard }) => {
    // Extracting relevant data from userData
    const subscriptionDetail = userData?.subscription_detail;
    const noOfTeams = userData?.no_of_teams;

    // Determine subscription status
    const isSubscriptionCancelled = subscriptionDetail?.status === 'canceled';
    const subscriptionCancelledPeriod = subscriptionDetail?.cancel_at_period_end;
    const isSubscriptionTrialing = subscriptionDetail?.status === 'trialing';
    const isSubscriptionActive = subscriptionDetail?.status === 'active';
    const isForeverSubscription = userData?.forever_subscription;

    // Default values in case subscriptionDetail or its nested properties are undefined
    const planInterval = subscriptionDetail?.items?.data?.[0]?.price?.recurring?.interval || 'month';
    const planIntervalCount = subscriptionDetail?.items?.data?.[0]?.price?.recurring?.interval_count || 1;
    const unitAmount = subscriptionDetail?.items?.data?.[0]?.price?.unit_amount / 100 || 0; // Convert cents to dollars
    const quantity = subscriptionDetail?.items?.data?.[0]?.quantity || 1; // Number of units purchased (e.g., teams)

    const currentPeriodEndTimestamp = subscriptionDetail?.current_period_end;
    const trialEndTimestamp = subscriptionDetail?.trial_end;
    const canceledAtTimestamp = subscriptionDetail?.canceled_at;
    const endedAtTimestamp = subscriptionDetail?.current_period_end;

    const totalAmount = unitAmount * quantity;

    // Format dates
    const formatDate = (timestamp) => {
        if (!timestamp) return 'N/A';
        const date = new Date(timestamp * 1000); // Convert seconds to milliseconds
        return moment(date).format('MMMM DD, YYYY'); // Using moment for consistent formatting
    };

    const nextPaymentDate = formatDate(currentPeriodEndTimestamp);
    const trialEndDate = formatDate(trialEndTimestamp);
    const cancellationDate = formatDate(canceledAtTimestamp);
    const subscriptionEndDate = isSubscriptionCancelled || subscriptionCancelledPeriod ? formatDate(endedAtTimestamp) : 'Ongoing (until cancelled)';

    const planDescription = `Billed each ${planIntervalCount > 1 ? `${planIntervalCount} ` : ''}${planInterval}`;
    const planName = `Premium ${planIntervalCount > 1 ? `${planIntervalCount} ` : ''}${planInterval.charAt(0).toUpperCase() + planInterval.slice(1)}`;


    return (
        <>
            {isForeverSubscription === "true" ?
                <>
                    <div className="common_card w-100 py-2" style={{ background: `var(--light-gray)` }}>
                        <div className="p-3 w-100 text-center">
                            <h4 style={{ color: `var(--dark-gray)` }}>Your Current Subscription Status</h4> {/* Slightly updated title */}

                            {/* Attractive Forever Free Access Message Card */}
                            <div className="mt-4 p-4" style={{
                                backgroundColor: 'var(--golden-light)',
                                borderRadius: '12px', // Slightly more rounded corners
                                border: '2px solid var(--golden)', // Thicker border
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' // Soft shadow for depth
                            }}>
                                <h5 className="mb-2" style={{ color: `var(--golden)`, fontWeight: 'bold', fontSize: '1.4rem' }}>
                                    🎉 Your Account: Congratulations!
                                </h5>
                                <p className="mb-3" style={{ color: `var(--dark-gray)`, fontSize: '1rem', lineHeight: '1.4' }}>
                                    Congratulations! You have **permanent free access** for your teams.
                                </p>

                                <div className="d-flex align-items-center justify-content-center my-3 p-2" style={{
                                    backgroundColor: 'var(--golden)', // Solid golden background
                                    borderRadius: '8px',
                                    color: 'white' // White text for contrast
                                }}>
                                    <span style={{
                                        fontSize: '2.5rem', // Even larger "10"
                                        fontWeight: 'bold',
                                        marginRight: '10px',
                                        lineHeight: '1' // Adjust line height for alignment
                                    }}>
                                        10
                                    </span>
                                    <span style={{
                                        fontSize: '1.5rem', // Larger "Teams"
                                        fontWeight: 'bold',
                                        lineHeight: '1' // Adjust line height for alignment
                                    }}>
                                        Teams Included
                                    </span>
                                </div>

                                <p className="mb-2" style={{ color: `var(--dark-gray)`, fontSize: '0.95rem' }}>
                                    You have **free** access to your teams. ({noOfTeams || 0} Teams Included) You currently have **{noOfTeams || 0} teams** registered, and they are fully covered by your club.
                                </p>
                                <p className="mb-0" style={{ color: `var(--dark-gray)`, fontSize: '0.9rem', fontStyle: 'italic' }}>
                                    No invoices, no renewals, no fuss!
                                </p>
                            </div>

                        </div>
                    </div>
                </>
                :
                <div className="common_card w-100 py-2" style={{ background: `var(--light-gray)` }}>
                    <div className="p-3 w-100">
                        {!canceledAtTimestamp &&
                            <div className='text-end mb-3'>
                                <button
                                    className="btn btn-success text-white fw-bold py-2 px-4 rounded shadow"
                                    onClick={() => setSubcard(false)}
                                >
                                    Change Current Plan
                                </button>
                            </div>
                        }
                        <h4 style={{ color: `var(--dark-gray)` }}>Your Current Subscription</h4>
                        <div className="d-flex justify-content-between align-items-center gap-2 mt-3">
                            <div>
                                <p className="mb-1" style={{ color: `var(--dark-gray)`, fontWeight: 'bold' }}>
                                    Plan: {planName}
                                </p>
                                <p className="mb-1" style={{ color: `var(--dark-gray)` }}>
                                    {planDescription}
                                </p>
                                {noOfTeams && (
                                    <p className="mb-1" style={{ color: `var(--dark-gray)` }}>
                                        No of Teams: {noOfTeams}
                                    </p>
                                )}
                            </div>
                            <h3 style={{ color: `var(--blue)` }}>
                                ${totalAmount.toFixed(2)}
                                <small style={{ color: `var(--dark-gray)` }}>/{planInterval}</small>
                            </h3>
                        </div>

                        <hr style={{ borderColor: `var(--dark-gray)`, opacity: 0.3 }} />

                        {isSubscriptionTrialing && !subscriptionCancelledPeriod && (
                            <>
                                <div className="d-flex justify-content-between align-items-center mt-3">
                                    <p className="mb-0" style={{ color: `var(--dark-gray)` }}>Trial End Date:</p>
                                    <p className="mb-0" style={{ color: `var(--green)`, fontWeight: 'bold' }}>{trialEndDate}</p>
                                </div>
                                <div className="d-flex justify-content-between align-items-center mt-2">
                                    <p className="mb-0" style={{ color: `var(--dark-gray)` }}>First Payment On:</p>
                                    <p className="mb-0" style={{ color: `var(--green)`, fontWeight: 'bold' }}>{nextPaymentDate}</p>
                                </div>
                                <div className="mt-4 text-center">
                                    <p className="mb-0" style={{ color: `var(--golden)`, fontWeight: 'bold' }}>
                                        You are currently on a free trial. You can cancel anytime before {trialEndDate}.
                                    </p>
                                </div>
                            </>
                        )}

                        {isSubscriptionActive && !isSubscriptionTrialing && !subscriptionCancelledPeriod && (
                            <>
                                <div className="d-flex justify-content-between align-items-center mt-3">
                                    <p className="mb-0" style={{ color: `var(--dark-gray)` }}>Next Payment Date:</p>
                                    <p className="mb-0" style={{ color: `var(--green)`, fontWeight: 'bold' }}>{nextPaymentDate}</p>
                                </div>
                                <div className="d-flex justify-content-between align-items-center mt-2">
                                    <p className="mb-0" style={{ color: `var(--dark-gray)` }}>Subscription End Date:</p>
                                    <p className="mb-0" style={{ color: `var(--dark-gray)` }}>{subscriptionEndDate}</p>
                                </div>
                            </>
                        )}

                        {isSubscriptionCancelled || subscriptionCancelledPeriod && (
                            <>
                                <div className="d-flex justify-content-between align-items-center mt-3">
                                    <p className="mb-0" style={{ color: `var(--dark-gray)` }}>Cancellation Date:</p>
                                    <p className="mb-0" style={{ color: `var(--red)`, fontWeight: 'bold' }}>{cancellationDate}</p>
                                </div>
                                <div className="d-flex justify-content-between align-items-center mt-2">
                                    <p className="mb-0" style={{ color: `var(--dark-gray)` }}>Subscription End Date:</p>
                                    <p className="mb-0" style={{ color: `var(--dark-gray)` }}>{subscriptionEndDate}</p>
                                </div>
                                <div className="mt-4 text-center">
                                    <p className="mb-0" style={{ color: `var(--golden)`, fontWeight: 'bold' }}>
                                        Your subscription was cancelled. You will not be billed further.
                                    </p>
                                </div>
                            </>
                        )}

                        {/* Show Cancel Subscription button only if not already cancelled */}
                        {!subscriptionCancelledPeriod && (
                            <div className="mt-4 text-center">
                                <button
                                    className="btn btn-outline-danger"
                                    style={{
                                        color: `var(--golden)`,
                                        borderColor: `var(--golden)`,
                                        backgroundColor: 'transparent',
                                        padding: '8px 20px',
                                        borderRadius: '5px',
                                        transition: 'all 0.3s ease',
                                    }}
                                    onFocus={(e) => {
                                        e.currentTarget.style.backgroundColor = `var(--golden)`;
                                        e.currentTarget.style.color = 'white';
                                    }}
                                    onBlur={(e) => {
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                        e.currentTarget.style.color = `var(--golden)`;
                                    }}
                                    onClick={() => setConfirmModal(true)}
                                >
                                    Cancel Subscription
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            }
        </>
    )
}

export default SubscriptionCard;